export const objectEntries = (object: object | null) => object !== null
  ? Object.entries(object)
  : [];
